document.addEventListener('DOMContentLoaded', () => {
    const tabButtons = document.querySelectorAll('[data-tab-target]');
    const tabContents = document.querySelectorAll('[data-tab]');

    if (tabButtons.length > 0) {
        // Attiva il primo tab
        const firstTarget = tabButtons[0].getAttribute('data-tab-target');
        tabButtons[0].setAttribute('data-active', '');
        const firstContent = document.querySelector(`[data-tab="${firstTarget}"]`);
        if (firstContent) {
            firstContent.setAttribute('data-active', '');
        }

        // Gestione click
        tabButtons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const target = btn.getAttribute('data-tab-target');

                // Rimuove data-active da tutti
                tabButtons.forEach((b) => b.removeAttribute('data-active'));
                tabContents.forEach((c) => c.removeAttribute('data-active'));

                // Attiva quelli cliccati/corrispondenti
                btn.setAttribute('data-active', '');
                const content = document.querySelector(`[data-tab="${target}"]`);
                if (content) {
                    content.setAttribute('data-active', '');
                }
            });
        });
    }
});
